import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { TicketSummaryDto } from './type/TicketSummaryDto';

const ENDPOINT = `${APIConfiguration.marketplace}orders`;

export interface ListOrderTicketsQueryArgs {
  orderId: string;
}

export const listOrderTicketsRequest = (
  payload: ListOrderTicketsQueryArgs,
): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${payload.orderId}/tickets`,
  config: { method: SUPPORTED_METHODS.GET },
});

export const listOrderTicketsQuery = async (
  payload: ListOrderTicketsQueryArgs,
): Promise<BackResponse<TicketSummaryDto[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<TicketSummaryDto[]>>(
      listOrderTicketsRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
